import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { UiContext } from 'uiContext';
import BreakTextContainer from 'components/baseElements/breakTextContainer';
import SpeedStatDesktop from 'components/speedStat/speedStatDesktop';
import { DateTypeStringHelper } from 'helpers/dateTimeStringHelper';
import ForecastDesktop from 'components/forecast/forecastDesktop';
import ExpandButton from 'controls/buttons/expandButton/expandButton';
import { ScoreItem } from 'mobx/commonTypes';

export type DropdownMenuHeaderDesktopProps = {
  traffic_score: ScoreItem;
  traffic_speed: {
    direct_speed: number;
    reverse_speed: number;
  };
  traffic_score_forecast: ScoreItem[];
  isOpen: boolean;
  onChangeIsOpen: (isOpen: boolean) => void;
};

export default function DropdownMenuHeaderDesktop({
  traffic_score,
  traffic_speed,
  traffic_score_forecast,
  isOpen,
  onChangeIsOpen,
}: DropdownMenuHeaderDesktopProps) {
  const {
    spacings: {
      uiElems: {
        header: { desktop },
      },
      sp,
    },
  } = useContext(UiContext);

  const dtHelper = new DateTypeStringHelper(traffic_score.dt);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: desktop.height,
        width: 1,
      }}
    >
      <Box
        sx={{
          'display': 'flex',
          'justifyContent': 'space-between',
          'alignItems': 'center',
          'width': 1,
          '& > *': {
            flexShrink: 0,
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: sp.s75,
          }}
        >
          <BreakTextContainer>
            <Typography sx={{ whiteSpace: 'nowrap' }} variant="f14">
              О ситуации
            </Typography>
            <Typography sx={{ whiteSpace: 'nowrap' }} variant="f14">
              на дорогах:
            </Typography>
          </BreakTextContainer>

          <SpeedStatDesktop
            score={traffic_score.score}
            directSpeed={traffic_speed.direct_speed}
            reverseSpeed={traffic_speed.reverse_speed}
            timeString={dtHelper.dateTime.time}
          ></SpeedStatDesktop>
        </Box>

        <Box
          sx={{
            display: 'flex',
            gap: sp.s75,
            alignItems: 'center',
          }}
        >
          <BreakTextContainer>
            <Typography variant="f14">Прогноз</Typography>
            <Typography variant="f14">Загруженности</Typography>
          </BreakTextContainer>

          <ForecastDesktop
            items={traffic_score_forecast.slice(0, 4)}
          ></ForecastDesktop>

          <ExpandButton
            isOpen={isOpen}
            onChangeIsOpen={onChangeIsOpen}
          ></ExpandButton>
        </Box>
      </Box>
    </Box>
  );
}
